import { ActionTypes } from "store/constants";

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

const getAllSlideinit = [];

export const getAllSlides = (state = getAllSlideinit, action) => {
  switch (action.type) {
    case ActionTypes.slides.get_slides:
      return action.payload;
    case ActionTypes.slides.set_slides:
    case ActionTypes.slides.create_slide:
      const slideExists = state.some((item) => item.id === action.payload.id);
      if (slideExists) {
        return state.map((item) =>
          item.id === action.payload.id ? { ...item, ...action.payload } : item
        );
      } else {
        return [...state, action.payload];
      }

    case ActionTypes.slides.delete_slide: {
      return state.map((item) => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            pages: item.pages.filter((x) => x.id !== action.payload.deleteId),
          };
        }
        return item;
      });
    }
    case ActionTypes.slides.delete_ebook_slide: { 
      return state.filter((item) => Number(item?.id) != (action.payload));
    }
    default:
      return state;
  }
};

const openSlideWidgetinit = {
  pageId: "",
  bookId: "",
  open: false,
  key: "slide_widget",
  id: 11,
  data: []
};

export const openSlideWidget = (state = openSlideWidgetinit, action) => {
  switch (action.type) {
    case ActionTypes.slides.open_widget:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
